<ng-container *appI18nScopeReady>
  <h2 mat-dialog-title class="role-preview__title">
    <mat-icon>badge</mat-icon>
    {{ 'preview_title' | i18n }}
  </h2>

  <mat-dialog-content class="role-preview__content">
    <p class="role-preview__hint">{{ 'preview_hint' | i18n }}</p>

    @if (activePreview(); as preview) {
      <output class="role-preview__active">
        <span>
          {{ 'currently_previewing' | i18n }}
          <strong>{{ preview.name }}</strong>
        </span>
        <button mat-stroked-button color="warn" (click)="exitPreview()">
          <mat-icon>logout</mat-icon>
          {{ 'exit_preview' | i18n }}
        </button>
      </output>
    }

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="role-preview__search">
      <mat-icon matPrefix>search</mat-icon>
      <mat-label id="role-preview-search-label">{{ 'search_roles' | i18n }}</mat-label>
      <input
        matInput
        id="role-preview-search"
        aria-labelledby="role-preview-search-label"
        #searchInput
        type="text"
        (input)="onSearchInput(searchInput.value)"
      />
    </mat-form-field>

    @if (isLoading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="role-preview__list">
      @for (role of filteredRoles(); track role._id) {
        <button
          type="button"
          class="role-preview__role"
          [class.is-active]="isActive(role)"
          (click)="selectRole(role)"
        >
          <span class="role-preview__role-name">{{ role.name }}</span>
          @if (role.description) {
            <span class="role-preview__role-desc">{{ role.description }}</span>
          }
          @if (isActive(role)) {
            <mat-icon class="role-preview__role-check">check</mat-icon>
          }
        </button>
      } @empty {
        @if (!isLoading()) {
          <p class="role-preview__empty">{{ 'no_roles' | i18n }}</p>
        }
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">{{ 'close' | i18n }}</button>
  </mat-dialog-actions>
</ng-container>
